export const BUS_APP_LAUNCH = 'launch-app'